import { render, staticRenderFns } from "./EnvironmentImportMetadata.vue?vue&type=template&id=1cbc50fa&"
import script from "./EnvironmentImportMetadata.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentImportMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports